import { SlCalender } from 'react-icons/sl';
import SearchInput from '../search-input/search-input.component';
import './message-section.styles.css';
import Tabel from '../tabel/tabel.component';
// import { tableData } from '../../data/tabelData';

const MessageSection = ({tableData}) => {
    return (
        <div className="message-section">
            {/* <div className="message-section-top-wrapper">
                <SearchInput />
                <button className="dashboard-calender-button">
                    <SlCalender />
                    Calender
                </button>
            </div> */}
            <Tabel data={tableData} />
        </div>
    )
}

export default MessageSection;